import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { BasketballGameLog, BasketballGameLogTypeLocalization, BasketballGameLogTypes, Game, GameUser } from '@mtgame/core';

@Component({
  selector: 'mtg-basketball-game-timeline-item',
  templateUrl: './basketball-game-timeline-item.component.html',
  styleUrls: ['./basketball-game-timeline-item.component.scss', '../../game/styles/timeline-item.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasketballGameTimelineItemComponent {
  private _gameLog: BasketballGameLog;
  private _gameUser: GameUser;
  @Input()
  game: Game;
  @Input()
  set gameLog(value: BasketballGameLog) {
    this._gameLog = value;
    this._gameUser = null;
  }
  get gameLog(): BasketballGameLog {
    return this._gameLog;
  }
  @Input()
  gameUsers: GameUser[];

  @HostBinding('class.score-type')
  get scoreType() {
    return this.gameLog.isPointsType();
  }

  gameLogTypes = BasketballGameLogTypes;
  gameLogTypeLocalization = BasketballGameLogTypeLocalization;

  @HostBinding('class.right')
  get rightPosition(): boolean {
    return this.teamId === this.game.competitorTeam.id;
  }

  get teamId() {
    return (this.gameUser && this.gameUser.teamUser.teamId) || this.gameLog.teamId;
  }

  get gameUser(): GameUser {
    if (!this._gameUser) {
      this._gameUser = (this.gameUsers || []).find(u => u.id === this.gameLog.gameUserId);
    }
    return this._gameUser;
  }
}

